import { useRouter } from 'expo-router'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../models'
import { BaseButton } from './BaseButton'

export const PlayPracticeGameButton = observer(() => {
  const router = useRouter()
  const {
    game: { clearWalkthrough, leaveCurrentGame, walkthroughType, teardown }
  } = useStore()

  const goToPracticeGame = () => {
    clearWalkthrough()
    leaveCurrentGame(false)
    teardown()

    router.replace('/game/new?simple=true')
  }

  return <BaseButton text="Play Practice Game" onPress={goToPracticeGame} outlined={walkthroughType === 'TableTour'} />
})
